import script from "./PageFilters.vue?vue&type=script&lang=js"
export * from "./PageFilters.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__